import { Command, HttpMethod } from "~/extensions/api";
export class GetInformationCommand extends Command {
    constructor(informationNo) {
        super(HttpMethod.Get, `information/${informationNo}`);
    }
}
